module.exports = __webpack_public_path__ + "prod/1.42.2/img/wx.e4308e9e.png";